import { render, staticRenderFns } from "./originaitem.vue?vue&type=template&id=359c2a78&scoped=true&"
import script from "./originaitem.vue?vue&type=script&lang=js&"
export * from "./originaitem.vue?vue&type=script&lang=js&"
import style0 from "./originaitem.vue?vue&type=style&index=0&id=359c2a78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359c2a78",
  null
  
)

export default component.exports